export enum ToastTypes {
  success = 'success',
  info = 'info',
  error = 'error',
  warning = 'warning',
}
